export const SITE = {
  name: "Allevamento Colli Storici",
  shortName: "Colli Storici",
  tagline: "Cura, passione e servizi completi per il mondo degli animali",
  phone: "+39 339 311 4327",
  phoneDisplay: "339 311 4327",
  phoneRaw: "393393114327",
  email: "info@collistorici.it",
  address: "Via Monaci Olivetani 13, 46040 Guidizzolo (MN)",
  mapsUrl:
    "https://www.google.com/maps?q=Via+Monaci+Olivetani+13,+46040+Guidizzolo+MN",
  mapsEmbed:
    "https://www.google.com/maps?q=Via%20Monaci%20Olivetani%2013%2C%2046040%20Guidizzolo%20MN&output=embed",
  whatsapp: "https://wa.me/393393114327",
  owner: "Nicola Bombana",
  partner: "Elisa",
  yearsExperience: "20+",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/allevamento", label: "Allevamento" },
  { to: "/toelettatura", label: "Toelettatura" },
  { to: "/pensione", label: "Pensione" },
  { to: "/cibo", label: "Cibo per cani" },
  { to: "/negozio", label: "Negozio & Pesca" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/contatti", label: "Contatti" },
];

export const IMG = {
  hero: "https://www.collistorici.it/wp-content/uploads/2024/08/IMG_6969-3.jpg",
  hero2: "https://www.collistorici.it/wp-content/uploads/2024/08/IMG_0775.jpg",
  cristal:
    "https://www.collistorici.it/wp-content/uploads/2017/10/Cristal-dei-Colli-Storici-Ufficiale.jpg",
  cuccioli:
    "https://www.collistorici.it/wp-content/uploads/2017/06/IMG-20170620-WA0017.jpg",
  toelettatura:
    "https://images.pexels.com/photos/6131161/pexels-photo-6131161.jpeg",
  pensione:
    "https://images.unsplash.com/photo-1591225721994-8dec7e2c7ffc?w=1600&q=80",
  cibo: "https://images.unsplash.com/photo-1591946559594-8c6d3b7391eb?w=1600&q=80",
  negozio:
    "https://images.unsplash.com/photo-1632862316541-0b75b0126544?w=1600&q=80",
  natura:
    "https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=1600&q=80",
  pesca:
    "https://images.unsplash.com/photo-1445363692815-ebcd599b6660?w=1600&q=80",
  famiglia:
    "https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=1600&q=80",
};
